import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = { class: "h-5 w-[35px] shrink-0 grow-0 overflow-hidden" };
import SvgIcon from '@atoms/SvgIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SwiperNavArrow',
    props: {
        direction: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            required: true,
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass([{
                        'origin-center rotate-180 transform': __props.direction === 'previous',
                        'pointer-events-none opacity-50': !__props.active,
                    }, "group flex max-w-max cursor-pointer items-center justify-start gap-1.5 text-sm font-bold transition hover:text-current"]),
                "data-swiper-nav-arrow": "",
                "aria-label": `${__props.direction} slide`
            }, [
                _createElementVNode("span", _hoisted_2, [
                    _createVNode(SvgIcon, {
                        class: "-translate-x-2 transform transition-transform group-hover:translate-x-0",
                        name: "arrow"
                    })
                ])
            ], 10, _hoisted_1));
        };
    }
});
